import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'AccountFund',
    column_type: 'id',
  },
  created_at: {
    model_name: 'AccountFund',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'AccountFund',
    column_type: 'datetime',
  },
  amount: {
    model_name: 'AccountFund',
    column_type: 'decimal',
  },
  share: {
    model_name: 'AccountFund',
    column_type: 'decimal',
  },
  account: {
    model_name: 'AccountFund',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'account',
      model_name: 'Account',
      foreign_key: 'account_id',
    },
  },
  account_id: {
    model_name: 'AccountFund',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'account',
      model_name: 'Account',
      foreign_key: 'account_id',
    },
  },
  fund: {
    model_name: 'AccountFund',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'fund',
      model_name: 'Fund',
      foreign_key: 'fund_id',
    },
  },
  fund_id: {
    model_name: 'AccountFund',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'fund',
      model_name: 'Fund',
      foreign_key: 'fund_id',
    },
  },
  already_video_record: {
    model_name: 'AccountFund',
    column_type: 'boolean',
  },
  last_confirm_date: {
    model_name: 'AccountFund',
    column_type: 'date',
  },
  revenue_datum: {
    model_name: 'AccountFund',
    column_type: 'has_one',
    extra: {
      polymorphic: '',
      association_name: 'revenue_datum',
      model_name: 'RevenueDatum',
      foreign_key: 'owner_id',
    },
  },
  owner_id: {
    model_name: 'AccountFund',
    column_type: 'has_one',
    extra: {
      polymorphic: '',
      association_name: 'revenue_datum',
      model_name: 'RevenueDatum',
      foreign_key: 'owner_id',
    },
  },
}

export const columnsExtend = (columns, filterColumnsExtend) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns, filterColumnsExtend)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
